import React from 'react';

import useStyles from './useStyles';

const Chip = ({ children }: Props) => {
  const classes = useStyles();

  return (
    <span className={classes.chip}>
      {children}
    </span>
  )
};

interface Props {
  children?: React.ReactNode;
}

export default Chip;
